import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SingleQuestionDialogOption {
  optionRank: number;
  feedbackOptionText: string;
}

export interface SingleQuestionDialogData {
  feedBackDate: string;
  admNo?: string;
  studentName?: string;
  questionId: number;
  question: string;
  questionLabel: string;
  options: SingleQuestionDialogOption[];
}

const RANK_PALETTE: Record<number, { border: string; background: string; circle: string }> = {
  1: { border: 'rgb(220, 38, 38)', background: 'rgba(220, 38, 38, 0.08)', circle: '#dc2626' },
  2: { border: 'rgb(234, 179, 8)', background: 'rgba(234, 179, 8, 0.14)', circle: '#ca8a04' },
  3: { border: 'rgb(249, 115, 22)', background: 'rgba(249, 115, 22, 0.1)', circle: '#f97316' },
  4: { border: 'rgb(14, 165, 233)', background: 'rgba(14, 165, 233, 0.1)', circle: '#0ea5e9' },
  5: { border: 'rgb(34, 197, 94)', background: 'rgba(34, 197, 94, 0.1)', circle: '#16a34a' },
};

@Component({
  selector: 'app-single-question-dialog',
  templateUrl: './single-question-dialog.component.html',
  styleUrls: ['./single-question-dialog.component.scss'],
})
export class SingleQuestionDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<SingleQuestionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SingleQuestionDialogData,
  ) { console.log('SingleQuestionDialogComponent data:', data);}

  close(): void {
    this.dialogRef.close();
  }

  getRankStyles(rank: number): { border: string; background: string; circle: string } {
    const safeRank = rank >= 1 && rank <= 5 ? rank : 1;
    return RANK_PALETTE[safeRank] ?? RANK_PALETTE[1];
  }

  normalizeRank(rank: number): number {
    return rank >= 1 && rank <= 5 ? rank : 1;
  }
}
